import { Stroke, Style, Circle, Fill } from "ol/style";
import { MultiPoint } from "ol/geom";
import {
  getNodeStyleNormal,
  getNodeStyleClick,
  getNodeStyleHover,
} from "./node";
import { getProperty, getPropertyEndingWith } from "./propertyExtraction";

export function getLrtcStyleNormal(feature) {
  return getLrtcColorStyle(feature, false, false).concat(
    getNodeStyleNormal(feature),
  );
}
export function getLrtcStyleClick(feature) {
  return getLrtcColorStyle(feature, true, false).concat(
    getNodeStyleClick(feature),
  );
}
export function getLrtcStyleHover(feature) {
  return getLrtcColorStyle(feature, false, true).concat(
    getNodeStyleHover(feature),
  );
}

function buildExtentMultiPoint(feature) {
  const geom = feature.getGeometry && feature.getGeometry();
  if (!geom || !geom.getFlatCoordinates) {
    return undefined;
  }
  const flatCoordinates = geom.getFlatCoordinates();
  if (!Array.isArray(flatCoordinates) || flatCoordinates.length < 2) {
    return undefined;
  }
  // Use original flatCoordinates as MultiPoint vertices (no extent / bbox)
  const points = [];
  for (let i = 0; i < flatCoordinates.length; i += 2) {
    points.push([flatCoordinates[i], flatCoordinates[i + 1]]);
  }
  return new MultiPoint(points);
}

function getLrtcColorStyle(feature, click, hover) {
  let color, width;
  let hdmapType = getProperty(feature, "hdmap");
  let laneRelation = getProperty(feature, "lane_relation");

  if (laneRelation === "crossing") {
    color = "orange";
    width = 6;
  } else if (hdmapType !== undefined && hdmapType === "lane_trajectory_line") {
    color = "green";
    width = 2;
  } else {
    color = "grey";
    width = 1;
  }

  if (hover || click) {
    width = 8;
  }

  const styles = [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];

  if (getPropertyEndingWith(feature, "-type") === "lane_relation") {
    // Visualize original flatCoordinates
    const multiPoint = buildExtentMultiPoint(feature);
    if (multiPoint) {
      let pointRadius = 3;
      if (hover || click) {
        pointRadius = 5;
      }
      styles.push(
        new Style({
          geometry: multiPoint,
          image: new Circle({
            radius: pointRadius,
            fill: new Fill({
              color: click ? "orange" : hover ? "yellow" : "white",
            }),
            stroke: new Stroke({ color: "blue", width: 1 }),
          }),
        }),
      );
    }
  }
  return styles;
}
